import React from 'react'

const Spinner = () => {
  return (
    <div className='loader overflow-hidden'></div>
  )
}

export default Spinner